import { useRef } from 'react';
import classNames from 'classnames';
import { useResizing } from 'hooks/useResizing';

import { SmallSpinner } from 'components/loading/Loading';

import { CardProps } from './types';

import cn from './Card.module.scss';

export const Card = ({
  minHeight,
  maxHeight,
  minWidth,
  maxWidth,
  padding = '16px',
  direction = 'row',
  loading = false,
  fit = false,
  children,
}: CardProps) => {
  const cardRef = useRef(null);
  const is_resizing = useResizing(cardRef);
  const is_loading = loading || is_resizing;

  return (
    <div
      ref={cardRef}
      className={classNames(cn.card, { [cn.fit]: fit })}
      style={{ minHeight, maxHeight, minWidth, maxWidth, padding }}
    >
      <div
        className={classNames(cn.content, 'transition', { [cn.dimmed]: is_loading })}
        style={{ flexDirection: direction }}
      >
        {children}
      </div>
      <div className={classNames(cn.loading, 'transition', { [cn.visible]: is_loading })}>
        <SmallSpinner />
      </div>
    </div>
  );
};
